<template>
  <div :class="['res_nav', { 'nav-hidden': isHidden }]">
    <v-app-bar class="nav-bar" dense>
      <v-row align="center" justify="space-between">
        <!-- Logo à gauche -->
        <v-col cols="4" class="d-flex justify-start align-center">
          <img
            src="@/assets/logo.png"
            alt="Logo"
            class="logo"
            @click="$router.push('/')"
            style="cursor: pointer"
          />
        </v-col>

        <!-- Texte au centre -->
        <v-col cols="4" class="d-flex justify-center align-center">
          <h1 class="center-text">Club Mizabook_FSBM</h1>
        </v-col>

        <!-- Icône de contact à droite -->
        <v-col cols="4" class="d-flex justify-end align-center">
          <svg
            @click="navigateToContactUs"
            width="32px"
            height="32px"
            class="contact-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 16C20.2091 16 22 14.2091 22 12C22 9.79086 20.2091 8 18 8"
              stroke="#ad7e3f"
              stroke-width="1.5"
              stroke-linejoin="round"
            />
            <path
              d="M6 8C3.79086 8 2 9.79086 2 12C2 14.2091 3.79086 16 6 16"
              stroke="#ad7e3f"
              stroke-width="1.5"
              stroke-linejoin="round"
            />
            <path
              d="M6 16V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V16C18 19.3137 15.3137 22 12 22"
              stroke="#ad7e3f"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </v-col>
      </v-row>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  inject: ["Emitter"],
  data() {
    return {
      isHidden: false, // Contrôle si la nav est cachée
      lastScrollPosition: 0, // Garde la trace de la dernière position du scroll
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // Ajoute un écouteur de scroll
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll); // Supprime l'écouteur
  },
  methods: {
    handleScroll() {
      const currentScroll = window.scrollY;

      if (currentScroll > this.lastScrollPosition && currentScroll > 50) {
        // Scroll vers le bas
        this.isHidden = true;
      } else if (currentScroll < this.lastScrollPosition) {
        // Scroll vers le haut
        this.isHidden = false;
      }

      this.lastScrollPosition = currentScroll;
    },
    navigateToContactUs() {
      this.$router.push("/Contactus"); // Redirige vers la page de contact
    },
  },
};
</script>

<style scoped>
/* Conteneur de la navigation */
.res_nav {
  position: fixed; /* Fixe la nav en haut */
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: transform 0.3s ease-in-out; /* Transition fluide */
}

/* Cache la nav lorsqu'elle est glissée vers le haut */
.nav-hidden {
  transform: translateY(-100%);
}

/* Style de la barre de navigation */
.nav-bar {
  background-color: #fdf1dd;
  padding: 0 16px;
  height: 64px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Style du logo */
.logo {
  height: 70px;
  max-width: 100px;
  margin-left: 50px;
  object-fit: contain;
}

/* Style du texte au centre */
.center-text {
  font-size: 24px;
  font-family: "Noto Kufi Arabic", sans-serif;
  font-weight: bold;
  color: #ad7e3f; /* Couleur dorée pour correspondre au thème */
  text-align: center;
  margin: 0;
  transition: color 0.3s ease-in-out; /* Transition fluide */
}

.center-text:hover {
  color: #97682b; /* Changement de couleur au survol */
}

/* Style de l'icône de contact */
svg {
  margin-right: 60px;
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

svg:hover {
  transform: scale(1.1);
  opacity: 0.8;
}
@media (max-width: 640px) {
  .center-text {
    display: none; /* Cache le texte sur les petits écrans */
  }
}
/* Responsive pour les petits écrans */
@media (max-width: 600px) {
  .logo {
    height: 50px; /* Taille réduite du logo */
    margin-left: 40px;
  }

  svg {
    margin-right: 60px;
    width: 28px;
    height: 28px;
  }
}
</style>
